<uis-optimized-image [source]="ICON.LoaderIcon" height="100" width="100" alt="loading indicator"></uis-optimized-image>
<div class="feefo-onpage-container">
	<div class="container">
		<div id="feefo-service-review-widgetId" class="feefo-review-widget-service"></div>
		<div class="feefo-review-badge-wrapper-product"></div>
	</div>
</div>
